import LazySwiperController from '@/utils/Controllers/LazySwiperController';
import SmarteditController from '@/utils/Controllers/SmarteditController';

export default () => {
  const createHowToVideoCarousel = () => {
    const entries = SmarteditController.getEditorialEntries(
      '.js-ken-howtoyoutubevideos',
    );
    Array.from(entries).forEach(async item => {
      const el = item.querySelector('.swiper-pagination');
      const nextEl = item.querySelector('.swiper-button-next');
      const prevEl = item.querySelector('.swiper-button-prev');

      const LazySwiperLib = await LazySwiperController();
      return new LazySwiperLib(item, {
        resistanceRatio: 0,
        centeredSlides: true,
        slidesPerView: 'auto',
        slideToClickedSlide: true,
        spaceBetween: 142,
        breakpoints: {
          1439: {
            spaceBetween: 80,
          },
          1023: {
            spaceBetween: 16,
          },
        },
        pagination: {
          clickable: true,
          el,
          type: 'bullets',
        },
        navigation: {
          nextEl,
          prevEl,
        },
      });
    });
  };
  SmarteditController.addOnReprocessPageListener(createHowToVideoCarousel);
  createHowToVideoCarousel();
};
